<template>
  <div class="table-responsive">
    <table class="table table-data min-w-table">
      <thead>
        <tr>
          <th v-text="'First Name'" />
          <th v-text="'Last Name'" />
          <th v-text="'Phone Number'" />
          <th
            class="w-16"
            v-text="'Status'"
          />
          <th v-text="'Status Timestamp'" />
        </tr>
      </thead>
      <tbody>
        <SMSDeliveryRow
          v-for="delivery in data.data"
          :key="delivery.uuid"
          :delivery="delivery"
        />
      </tbody>
    </table>
    <CommPagination :pagination="data.meta.pagination" />
  </div>
</template>

<script type="text/babel">
import SMSDeliveryRow from './SMSDeliveryRow'
import CommPagination from './CommPagination'

export default {
  name: 'SmsDeliveries',
  components: {
    CommPagination,
    SMSDeliveryRow,
  },
  props: {
    smsUuid: {
      type: String,
      required: true,
    },
    page: {
      type: [String, Number],
      required: false,
      default: 1,
    },
    status : {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    data() {
      return this.$store.state.communication.SMSDeliveries
    },
  },
  async mounted() {
    await this.$nextTick()

    this.fetchDeliveries()
  },
  methods: {
    fetchDeliveries() {
      this.$store.dispatch('communicationSetSMSDeliveries', {
        uuid: this.smsUuid,
        page: this.page,
        status: this.status,
      })
    },
  },
}
</script>
